import axios from 'axios'
import {
  ChatNotificationResponse,
  StatusNotificationResponse,
  NotificationParams,
} from '../../types/notificationTypes'

const API_URL = process.env.REACT_APP_API_CLAIM_URL

/**
 * Get auth token from localStorage
 */
const getAuthToken = (): string | null => {
  const authData = localStorage.getItem('kt-auth-react-v')
  if (authData) {
    try {
      const parsed = JSON.parse(authData)
      return parsed?.token || null
    } catch {
      return null
    }
  }
  return null
}

/**
 * Fetch chat notifications
 * @param params - Query parameters
 * @returns ChatNotificationResponse
 */
export const getChatNotifications = async (
  params: NotificationParams = {}
): Promise<ChatNotificationResponse> => {
  const token = getAuthToken()

  const queryParams = new URLSearchParams()

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString())
  }
  if (params.cursor) {
    queryParams.append('cursor', params.cursor)
  }
  if (params.claimNumber) {
    queryParams.append('claimNumber', params.claimNumber)
  }
  if (params.onlyUnread !== undefined) {
    queryParams.append('onlyUnread', params.onlyUnread.toString())
  }
  if (params.sortDirection) {
    queryParams.append('sortDirection', params.sortDirection)
  }

  const url = queryParams.toString()
    ? `${API_URL}/api/Provider/ChatNotifications?${queryParams.toString()}`
    : `${API_URL}/api/Provider/ChatNotifications`

  const response = await axios.get<ChatNotificationResponse>(url, {
    headers: {
      Accept: 'text/plain',
      Authorization: `Bearer ${token}`,
    },
  })

  return response.data
}

/**
 * Fetch status notifications
 * @param params - Query parameters
 * @returns StatusNotificationResponse
 */
export const getStatusNotifications = async (
  params: NotificationParams = {}
): Promise<StatusNotificationResponse> => {
  const token = getAuthToken()

  const queryParams = new URLSearchParams()

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString())
  }
  if (params.cursor) {
    queryParams.append('cursor', params.cursor)
  }
  if (params.claimNumber) {
    queryParams.append('claimNumber', params.claimNumber)
  }
  if (params.onlyUnread !== undefined) {
    queryParams.append('onlyUnread', params.onlyUnread.toString())
  }
  if (params.sortDirection) {
    queryParams.append('sortDirection', params.sortDirection)
  }

  const url = queryParams.toString()
    ? `${API_URL}/api/Provider/ClaimStatusNotifications?${queryParams.toString()}`
    : `${API_URL}/api/Provider/ClaimStatusNotifications`

  const response = await axios.get<StatusNotificationResponse>(url, {
    headers: {
      Accept: 'text/plain',
      Authorization: `Bearer ${token}`,
    },
  })

  return response.data
}

export const notificationService = {
  getChatNotifications,
  getStatusNotifications,
}

export default notificationService
